import VectorSource from 'ol/source/Vector';

import { logger } from 'cadenza/utils/logging';
import { SketchFormat } from 'cadenza/workbook/sketch/sketch-layer/sketch-format';
import { getRenderingStrategy } from 'cadenza/workbook/sketch/sketch-layer/sketch-style';
import { loadSketchLayerItems } from 'cadenza/api-client/sketch-api';
import type { Map } from 'cadenza/map/map';

import type Feature from 'ol/Feature';
import type { Geometry } from 'ol/geom';

export class SketchLayerSource extends VectorSource<Geometry> {

  _url?: string;
  _isSilent = false;

  constructor (map: Map, url?: string) {
    const renderingStrategy = getRenderingStrategy(map);
    super({
      format: new SketchFormat(),
      loader: async () => {
        try {
          const items = await loadSketchLayerItems(this.getUrl());
          const format: SketchFormat = this.getFormat() as SketchFormat;
          const features = format.readFeatures(items);
          features.forEach(async feature => await renderingStrategy(feature));
          this.addFeaturesSilently(features);
        } catch (error) {
          logger.error('Failed to get sketch layer features', error);
        }
      },

      useSpatialIndex: false // ensure feature order
    });
    this._url = url;
  }

  getUrl () {
    return this._url;
  }

  setUrl (url: string) {
    if (url === this._url) {
      return;
    }
    this._url = url;
    this.refresh();
  }

  isSilent () {
    return this._isSilent;
  }

  addFeaturesSilently (features: Feature[]) {
    this._isSilent = true;
    this.addFeatures(features);
    this._isSilent = false;
  }

  removeFeaturesSilently (features: Feature[]) {
    this._isSilent = true;
    features.forEach(feature => {
      this.removeFeature(feature);
    });
    this._isSilent = false;
  }

}
